import React, { useEffect } from 'react';
import '../Styles.css';
import { useSelector, useDispatch } from 'react-redux';
import Header from './Header';
import Form from './Form';
import Todos from './Todos';
import Tools from './Tools';

import {
  createTodo, deleteTodo, toggleStatus, sortTodos,
} from '../actions/todosActions';

const App = () => {
  const dispatch = useDispatch();
  const todos = useSelector(state => state.todoApp);
  useEffect(() => {
    localStorage.todos = JSON.stringify(todos);
  });
  const onHandleSubmit = e => {
    e.preventDefault();
    const title = e.target.title.value;
    const description = e.target.description.value;
    const tags = (e.target.tags.value) ? e.target.tags.value.split(',').map(i => i.trim()) : [];
    const newCard = {
      id: Date.now(),
      title,
      description,
      status: 'pending',
      hidden: false,
      editMode: false,
      tags,
    };
    e.target.title.value = '';
    e.target.description.value = '';
    e.target.tags.value = '';
    dispatch(createTodo(newCard));
    dispatch(sortTodos());
  };
  const onToggleStatus = index => {
    dispatch(toggleStatus(todos.findIndex(todo => todo.id === index)));
    dispatch(sortTodos());
  };

  const onRemoveCard = index => {
    dispatch(deleteTodo(todos.findIndex(todo => todo.id === index)));
  };

  return (
    <div className="App__container">
      <Header />
      <div className="content__container">
        <div className="content__sidebar">
          <Form onHandleSubmit={onHandleSubmit} />
          <Tools />
        </div>
        {todos.length > 0 ? (
          <Todos
            onToggleStatus={onToggleStatus}
            onRemoveCard={onRemoveCard} />
        ) : '' }
      </div>
    </div>
  );
};

export default App;
